import { z } from 'zod';

export const ChannelTypeSchema = z.enum([
  'digital_input',
  'digital_output',
  'analog_input',
  'analog_output',
  'counter',
  'pwm',
]);

export const ChannelSchema = z.object({
  id: z.string().min(1),
  board_id: z.string().min(1),
  pin: z.number().int().min(0).max(255),
  name: z.string().min(1),
  channel_type: ChannelTypeSchema,
  scaling_factor: z.number(),
  scaling_offset: z.number(),
  units: z.string().nullable(),
  safe_state: z.number().nullable(),
  alarm_min: z.number().nullable(),
  alarm_max: z.number().nullable(),
  // FK to Subsystem doc (Plan 17). Nullable — channels with no assigned
  // subsystem carry null. Plan 15.1 migration populates this from the
  // MFVB string label via the derived Subsystem docs.
  subsystem_id: z.string().nullable(),
  archived_at_ms: z.number().int().nullable(),
  created_at_ms: z.number().int().nonnegative(),
  updated_at_ms: z.number().int().nonnegative(),
});

export const UpdateChannelSchema = z.object({
  name: z.string().min(1).optional(),
  channel_type: ChannelTypeSchema.optional(),
  scaling_factor: z.number().optional(),
  scaling_offset: z.number().optional(),
  units: z.string().optional(),
  safe_state: z.number().optional(),
  alarm_min: z.number().optional(),
  alarm_max: z.number().optional(),
  subsystem_id: z.string().nullable().optional(),
});

export type ParsedChannel = z.infer<typeof ChannelSchema>;
export type ParsedUpdateChannel = z.infer<typeof UpdateChannelSchema>;
